// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__dSt5Q","total":"Cart_total__PgKcN","actions":"Cart_actions__VB7Cp","button--alt":"Cart_button--alt__juv8m","button":"Cart_button__LFPiA"};